export default __webpack_public_path__ + "static/media/progress.684b4b04.jpg";